import type { GenericOrderItem } from 'app/src/model'
import { calculateDisplayValue, getNormalizedDetailsUrl } from 'app/src/shared/helpers'
import { useTranslation, useWelfarePortalNavigate } from 'app/src/shared/hooks'

import { DateTime } from 'luxon'
import { Button } from 'primereact/button'
import { Chip } from 'primereact/chip'
import { Tooltip } from 'primereact/tooltip'
import { useEffect, useRef, useState, type ReactElement } from 'react'

export function OrderListItemSmallContent(props: { item: GenericOrderItem }): ReactElement {
  const orderDate = DateTime.fromISO(props.item.orderDate)
  const { navigateDelegate } = useWelfarePortalNavigate()
  const { t } = useTranslation('productDetail')
  const nameRef = useRef<HTMLDivElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useEffect(() => {
    const el = nameRef.current
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth)
    }
  }, [props.item.productName])

  const hangleNavigate = () => {
    if (props?.item?.detailsLink) {
      const normalizedUrl = getNormalizedDetailsUrl(props.item.detailsLink!)
      navigateDelegate(normalizedUrl)
    }
  }

  const getDiscountLabel = (discountType?: string): string => {
    if (discountType === 'percentage') {
      return t('ProductDetail.discount.percentage')
    } else if (discountType === 'fixed') {
      return t('ProductDetail.discount.fixed')
    }
    return t('ProductDetail.discount.generic')
  }
  return (
    <>
      <div className='grid w-full gap-1'>
        <div className='grid grid-cols-[1fr_auto] items-center gap-1'>
          {isTruncated && <Tooltip target={nameRef} content={props.item.productName} position='mouse' />}
          <div ref={nameRef} className='h-[22px] truncate font-bold'>
            {props.item.productName}
          </div>
          <Chip label={props.item.status} />
        </div>
        <div className='grid grid-cols-2 items-center'>
          <div>
            <div className='inline size-[21px] h-[31.5px] font-bold'>{orderDate.toFormat('dd')}</div>{' '}
            <div className='inline size-4 h-[22px] font-bold'>{orderDate.toFormat('MMM').toUpperCase()}</div>{' '}
            <div className='inline'>{orderDate.toFormat('yyyy')}</div>
          </div>
          <div className='text-right'>
            <div>{props.item.priceLabel === 'sconto' ? getDiscountLabel(props.item.discountType) : props.item.priceLabel}</div>
            <div className='text-size-[16px] h-[31.5px] font-bold'>{calculateDisplayValue(props.item)}</div>
          </div>
        </div>
      </div>
      <div className='mt-2 self-center text-center'>
        <Button
          rounded
          label={props.item.seeDetailsLabel}
          aria-label={`${props.item.seeDetailsLabel} per ${props.item.productName}`}
          // the event normalizes the link removing the leading '#/' if present
          onClick={hangleNavigate}
        />
      </div>
    </>
  )
}
